import { makeContext } from "@shared/utils/makeContext";

// --- Name ---
const NAME = "Dialog";

// --- State & Actions ---
export type DialogState = {
  activeDialog: string | null;
  dialogProps?: Record<string, any>;
};

export const DIALOG_OPEN = "dialog/open";
export const DIALOG_CLOSE = "dialog/close";

export const ACTION_TYPES = {
  DIALOG_OPEN,
  DIALOG_CLOSE,
} as const;

export type DialogAction =
  | { type: typeof DIALOG_OPEN; payload: { dialog: string; props?: any } }
  | { type: typeof DIALOG_CLOSE; payload: { dialog: string } };

const initialDialogState: DialogState = {
  activeDialog: null,
  dialogProps: undefined,
};

// --- Reducer ---
function dialogReducer(state: DialogState, action: DialogAction): DialogState {
  switch (action.type) {
    case DIALOG_OPEN:
      return {
        activeDialog: action.payload.dialog,
        dialogProps: action.payload.props ?? {},
      };
    case DIALOG_CLOSE:
      return {
        activeDialog: null,
        dialogProps: undefined,
      };
    default:
      throw new Error(`Unknown action: ${action.type}`);
  }
}
// --- Generate Context ---
export const {
  Provider: DialogProvider,
  useState: useDialogState,
  useDispatch: useDialogDispatch,
} = makeContext<DialogState, DialogAction>({
  name: NAME,
  reducer: dialogReducer,
  initialState: initialDialogState,
});
